<!--打分面板-->
<template>
	<div class="mark-bard">
		<div class="mark-board-content" ref="board" v-show="isDisplayMarkScoreBoard">
			<div class="account">
				登录帐号: {{ allBasicInfo.userName || allBasicInfo.markName }}
				<i class="iconfont iconcha" @click.stop.prevent="closeMarkBoard" title="关闭打分"></i>
				<i class="iconfont iconzuixiaohua" title="最小化打分" v-show="!isHistoryState" @click.stop.prevent="miniScoreBoard"></i>
			</div>
			<ul>
				<li class="score" v-for="(item, index) in scoreList" :key="index">
					<div class="score-title">{{ `${item.bigTopic}.${item.smallTopic}` }}</div>
					<div class="score-num" :class="{ 'score-num-active': index === currentIndex }">
						<input
							ref="scoreListInput"
							type="text"
							class="score-input"
							:maxLength="5"
							v-model.number="item.getScore"
							@focus="currentQsFocus(item, index)"
							@keyup="currentInputKeyUp(index, $event)"
							:placeholder="`0~${item.score}`"
						/>
					</div>
					<div class="btn" @click="fullScore(item.score, index)">{{ item.score }}分</div>
					<div class="btn yellow-btn" @click="zeroScore(index)">0分</div>
				</li>
			</ul>
			<div class="total-ope" style="display: none">
				<div class="all-btn-wrap">
					<div class="all-right all-btn" @click="allRight">全对</div>
					<div class="all-wrong all-btn" @click="allWrong">全错</div>
				</div>
			</div>
			<div class="score-info">
				<div class="total-score">
					总得分：<span class="total">{{ totalScore }}分</span>
				</div>
				<div class="step-state">
					{{ originStep > 0 ? '固定步长：' : '最小步长：' }}
					<span class="step-state-val">{{ stepVal }}</span>
				</div>
			</div>
			<div class="ope-check-box">
				<el-checkbox label="自动提交" v-model="isSelAutoSubmit" :disabled="!isShowAutoSubmit" @change="aotuSubmitChange" border />
				<el-checkbox label="快捷打分" v-model="isSelFastScoreBoard" @change="fastClickChange" border />
				<el-checkbox label="打分板" v-model="isSelScoreBoard" @change="labelChange" border style="margin-left: 0" />
				<el-checkbox label="横排" v-model="isSelHorizontalPage" :disabled="isHistoryState || isFastScoreState" @change="horizontalChange" border />
				<el-checkbox label="答案" v-model="isAnswer" @change="answerChange" border />
			</div>
			<div class="btn-wrap" v-show="query.type == 2 && Number(allBasicInfo.studentId) >= 0">
				<div class="next-qus final-btn" style="margin-left: 0" @click="lookExamPaper">查看原卷</div>
			</div>
			<div class="btn-wrap">
				<div class="submit final-btn" :class="{ 'loading-btn-state': loadingState }" @click="submitScoreBtn">
					{{ isHistoryState ? '保存修改' : '提交' }}
				</div>
				<div
					class="final-btn"
					style="background: #009688;border: 1px solid #009688;margin-left: 20px"
					v-show="isHistoryState"
					@click="historyBackToExamPaper"
				>
					返回阅卷
				</div>
			</div>
		</div>
		<guide
			:class="{ 'score-board-guide': guideStep === 5, 'fast-score-board-guide': guideStep === 6, 'band-score-board-guide': guideStep === 8 }"
			v-if="guideStep === 5 || guideStep === 6 || guideStep === 8"
			:title="guideStepVal[guideStep].title"
			:distribute="guideStepVal[guideStep].distribute"
			:isTopArr="false"
		/>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import dragMixin from '../../../mixin/drag-mixin'
import guideMixin from '../utils/guide-mixin'
import { isAllGetScore } from '../utils/help'
export default {
	name: 'board',
	mixins: [dragMixin, guideMixin],
	props: {
		boardChoseScore: {
			type: Function
		}
	},
	components: { guide: () => import('./guide') },
	data() {
		return {
			//起始步长
			originStep: 0,
			//步长值
			stepVal: 0.5,
			//no use
			checkList: [],
			//得分列表
			scoreList: [],
			//当前索引
			currentIndex: 0,
			//总分
			totalScore: 0,
			//基本信息
			allBasicInfo: {},
			//query
			query: this.$route.query,
			//开始时间
			startTime: 0,
			//快捷打分 打分点列表
			imgAddrMarkList: [],
			//是不是阅卷记录状态
			isHistoryState: false,
			//是否是快捷打分状态
			isFastScoreState: false,
			//是否自动提交
			isAutoSubmit: true,
			//是否显示自动提交 按钮
			isShowAutoSubmit: true,
			//图片是否水平拼接
			isHorizontalImage: true,
			//是否选择打分版打分
			isSelScoreBoard: false,
			//是否选择快捷打分
			isSelFastScoreBoard: false,
			//是否选择自动提交
			isSelAutoSubmit: true,
			//是否选择 横排
			isSelHorizontalPage: true,
			//no use
			isSelCacheState: false,
			//快捷打分 加分还是减分
			fastScoreKey: null,
			//位置
			dragStartX: -25,
			dragStartY: 0,
			//no use
			progressInfoNum: 0,
			//loading
			loadingState: false,
			// 是否显示当前面板
			isDisplayMarkScoreBoard: true,
			//是否溴铵是快捷打分面板
			fastScoreBoardState: false,
			//面板状态
			markBoardState: true,
			//打分是否合法
			isScoreLegal: true,
			//no use
			rotateDegree: 0,
			////no use
			scaleState: 1,
			//是哪一种打分方式
			examType: null,
			examRemark: '',
			guideStepVal: {
				5: { title: '打分板', distribute: '打分板包括快捷打分，打分板打分和键盘打分，还可以实现试卷横排展示 ' },
				6: { title: '快捷打分', distribute: '选中快捷打分，出现快捷打分面板' },
				8: { title: '打分板打分', distribute: '选中快捷打分，出现快捷打分面板' }
			},
			//是否显示答案
			isAnswer: false
		}
	},
	created() {
		this.examType = this.query.type
	},
	mounted() {
		this.getScoreList()
		this.watchCurrentCompEmit()
		this.getScreenWidth()
		this.eventBus.$emit('isAutoSubmitPage', this.isAutoSubmit)
		this.$nextTick(() => {
			this.dragStartY = 35
			this.$refs['board'].style.transform = `translateX(${this.dragStartX}px) translateY(${this.dragStartY}px)`
		})
		const _this = this
		document.onkeydown = function() {
			let key = window.event.keyCode
			if (key === 13 && _this.isFastScoreState) _this.submitScore()
		}
	},
	methods: {
		...mapActions('examination/databases', ['set', 'get', 'del']),
		// 监听所用的emit
		watchCurrentCompEmit() {
			this.eventBus.$on('isTypical', cb => {
				if (cb.state) {
					this.examType = 1
					this.examRemark = cb.text
				} else {
					this.examType = this.query.type
				}
			})
			this.eventBus.$on('isScoreBoardState', cb => (this.isSelScoreBoard = cb))
			this.eventBus.$on('horizontalChange', cb => (this.isSelHorizontalPage = cb))
			this.eventBus.$on('progressInfo', cb => (this.progressInfoNum = cb.initProNum))
			this.eventBus.$on('originStepScore', cb => (this.originStep = cb))
			this.eventBus.$on('isHistoryState', cb => (this.isHistoryState = cb))
			this.eventBus.$on('startTime', cb => (this.startTime = cb))
			this.eventBus.$on('fastScoreBoardState', cb => (this.fastScoreBoardState = cb))
			this.eventBus.$on('emitScoreCurrentIndex', cb => (this.currentIndex = cb))
			this.eventBus.$on('isDisableSubmitBtn', cb => (this.loadingState = cb))
			this.eventBus.$on('isDisplayMarkScoreBoard', cb => (this.isDisplayMarkScoreBoard = cb))
			this.eventBus.$on('imgAddrListInfo', cb => (this.imgAddrMarkList = cb.imgAddrList))

			this.eventBus.$on('guideStepFastClick', cb => this.fastClickChange(cb))
			this.eventBus.$on('guideStepScoreBoard', cb => this.labelChange(cb))

			this.eventBus.$on('changeFastScoreInfo', cb => {
				this.fastScoreKey = cb.key
				if (cb.isToZero !== 'isToZero') {
					this.statusChangeFastScore(cb)
				}
			})
			this.eventBus.$on('emitScoreList', cb => {
				this.scoreList = []
				this.scoreList = cb
				this.getTotalScore()
			})
			this.eventBus.$on('markBoardState', cb => {
				this.markBoardState = cb
				if (!cb) {
					this.initMarkScoreBoardState()
				}
			})
			this.eventBus.$on('isShowAutoSubmit', cb => {
				this.isShowAutoSubmit = cb
				this.isSelAutoSubmit = cb
			})
			this.eventBus.$on('fastScoreHandleMark', cb => {
				this.fastClickOperateScore(cb)
				this.getTotalScore()
			})
			this.eventBus.$on('isFastScoreState', cb => {
				this.isFastScoreState = cb
				if (cb) {
					this.isSelFastScoreBoard = true
				} else {
					this.isSelFastScoreBoard = false
				}
			})
			this.eventBus.$on('isCacheNextData', cb => {
				if (!cb) {
					this.isSelCacheState = false
				}
			})
			this.eventBus.$on('emitCurrentStepScore', async cb => {
				const pathKey = this.query.markingTaskId + this.scoreList[this.currentIndex].pkId
				const localSel = await this.get({ dbName: 'database', path: 'scoreStep.' + pathKey, user: true })
				// this.stepVal = 0
				if (cb.stepScore > 0) {
					this.stepVal = cb.stepScore
				} else if (localSel && cb.stepScore === 0) {
					this.stepVal = localSel
				}
			})
			this.emitAllScoreState()
		},
		// 屏幕宽度
		getScreenWidth() {
			if (window.screen.width <= 1920) {
				this.dragStartX = -35
			}
		},
		// 历史转台返回到正常阅卷
		historyBackToExamPaper() {
			this.eventBus.$emit('horizontalChange', false)
			this.eventBus.$emit('historyBoardState', false)
			this.eventBus.$emit('isHistoryState', false)
			this.eventBus.$emit('isCacheNextData', false)
			this.eventBus.$emit('isFastScoreState', false)
			this.eventBus.$emit('isShowAutoSubmit', true)
			this.eventBus.$emit('isAutoSubmitPage', true)
			this.eventBus.$emit('isTypical', { state: false })
			this.eventBus.$emit('flushData')
			localStorage.removeItem('finalCanNotExam')
			this.del({ dbName: 'database', path: 'nextData', delKey: '', user: true })
		},
		// 查看答题卡
		lookExamPaper() {
			this.eventBus.$emit('originColumnBoardState', true)
		},
		// 初始化 board 状态
		initMarkScoreBoardState() {
			this.imgAddrMarkList = {}
			this.scoreList.forEach(res => {
				res.getScore = null
			})
			this.isShowAutoSubmit = true
			this.eventBus.$emit('emitScoreList', this.scoreList)
			this.eventBus.$emit('imgAddrListInfo', { imgAddrList: this.imgAddrMarkList })
		},
		// 关闭操作板
		closeMarkBoard() {
			this.eventBus.$emit('markBoardState', false)
			this.eventBus.$emit('scoreBoardState', false)
			this.eventBus.$emit('fastScoreBoardState', false)
		},
		// 快速阅卷 加分/减分 切换
		statusChangeFastScore(val) {
			this.scoreList.forEach(res => {
				res.getScore = null
			})
			if (val.key === '+') {
				this.scoreList[0].getScore = 0
			} else if (val.key === '-') {
				this.scoreList[0].getScore = this.scoreList[0].score
			}
			this.emitAllScoreState()
		},
		// 输入 focus
		currentQsFocus(item, index) {
			this.currentIndex = index
			this.eventBus.$emit('emitScoreCurrentIndex', this.currentIndex)
			this.eventBus.$emit('originStepScore', item.stepScore)
			this.emitCurrentStepScoreFun()
			this.emitAllScoreState()
			if (this.isSelFastScoreBoard && this.fastScoreKey === '+' && this.scoreList[this.currentIndex].getScore === null) {
				this.scoreList[this.currentIndex].getScore = 0
			} else if (this.isSelFastScoreBoard && this.fastScoreKey === '-' && this.scoreList[this.currentIndex].getScore === null) {
				this.scoreList[this.currentIndex].getScore = this.scoreList[this.currentIndex].score
			}
		},
		// 输入 key up enter 0.1
		currentInputKeyUp(index, event) {
			const reg = /^([1-9]\d*|0)(\.\d{1})?$/
			//|| (this.stepVal != 0 && Number(event.target.value) % this.stepVal !== 0)
			if (!reg.test(Number(event.target.value))) {
				this.scoreList[index].getScore = ''
				this.getTotalScore()
				this.$forceUpdate()
				this.$message({ message: '打分不是有效的数字：' + event.target.value, type: 'error', duration: 3000, dangerouslyUseHTMLString: true })
				return false
			}

			if (event.key === 'Enter') {
				this.keyUpEnter(index)
			} else {
				this.keyUpNumber(index, event.target.value)
			}
		},
		// 数字键
		keyUpNumber(index, num) {
			this.scoreList[index].getScore = num
			this.getTotalScore()
			this.emitAllScoreState()
			this.judgeScore()
		},
		// enter 键盘
		keyUpEnter(index) {
			this.judgeScore()
			this.currentIndex = index + 1
			isAllGetScore(this.scoreList).then(res => {
				if (this.isAutoSubmit && res) {
					this.submitScore()
					this.currentIndex = 0
					this.$refs['scoreListInput'][0].focus()
					this.eventBus.$emit('emitScoreCurrentIndex', this.currentIndex)
					return false
				} else if (!this.isAutoSubmit && res) {
					this.$message({ message: '已完成，请提交', type: 'success', duration: 3000 })
					return false
				}
			})
			this.currentIndex = index + 1 === this.scoreList.length ? this.scoreList.length - 1 : index + 1
			this.emitAllScoreState()
			this.$refs['scoreListInput'][this.currentIndex].focus()
		},
		// 判断打的分是否超过了最高分
		judgeScore() {
			this.isScoreLegal = true
			this.scoreList.forEach(res => {
				if (Number(res.getScore) > res.score) {
					this.isScoreLegal = false
					this.$message({ type: 'error', message: '打分不能超过题块总分：' + res.score, duration: 3000, dangerouslyUseHTMLString: true })
				}
			})
		},
		// 获取题目列表
		getScoreList() {
			this.eventBus.$on('emitScoreList', cb => {
				let resultArr = []
				cb.forEach(res => {
					resultArr.push(Object.assign({}, res, { getScore: null }))
				})
				this.scoreList = resultArr
			})
			this.eventBus.$on('basicInformation', cb => (this.allBasicInfo = cb))
		},
		// 快捷打分--> 分数操作
		fastClickOperateScore(cb) {
			if (cb.scoreState === '+') {
				this.scoreList[this.currentIndex].getScore = Number(this.scoreList[this.currentIndex].getScore) + Number(cb.scoreNum)
				if (this.scoreList[this.currentIndex].getScore >= this.scoreList[this.currentIndex].score) {
					this.scoreList[this.currentIndex].getScore = this.scoreList[this.currentIndex].score
					this.currentIndex += 1
					if (this.currentIndex > this.scoreList.length - 1) {
						this.currentIndex = this.scoreList.length - 1
					} else {
						this.scoreList[this.currentIndex].getScore = 0
					}
					this.eventBus.$emit('emitScoreCurrentIndex', this.currentIndex)
					if (this.currentIndex < this.scoreList.length) {
						this.emitCurrentStepScoreFun()
					}
				}
			} else if (cb.scoreState === '-') {
				this.scoreList[this.currentIndex].getScore -= Number(cb.scoreNum)
				if (this.scoreList[this.currentIndex].getScore <= 0) {
					this.scoreList[this.currentIndex].getScore = 0
					this.currentIndex += 1
					if (this.currentIndex > this.scoreList.length - 1) {
						this.currentIndex = this.scoreList.length - 1
					} else {
						this.scoreList[this.currentIndex].getScore = this.scoreList[this.currentIndex].score
					}
					this.eventBus.$emit('emitScoreCurrentIndex', this.currentIndex)
					if (this.currentIndex < this.scoreList.length) {
						this.emitCurrentStepScoreFun()
					}
				}
			}
			this.eventBus.$emit('emitScoreList', this.scoreList)
			this.eventBus.$emit('originStepScore', this.scoreList[this.currentIndex].stepScore)
		},
		// 派发 current step
		async emitCurrentStepScoreFun() {
			this.eventBus.$emit('emitCurrentStepScore', this.scoreList[this.currentIndex])
		},
		// 打分板
		labelChange(val) {
			//  isHistoryState || isFastScoreState
			this.eventBus.$emit('scoreBoardState', val)
			this.eventBus.$emit('isScoreBoardState', val)
			this.eventBus.$emit('isFastScoreState', false)
			this.eventBus.$emit('fastScoreBoardState', false)
			//----------
			if (val && !this.isHistoryState) {
				this.eventBus.$emit('isAutoSubmitPage', val)
				this.eventBus.$emit('isShowAutoSubmit', val)
				this.isAutoSubmit = val
			}
			if (this.isHistoryState) {
				this.eventBus.$emit('isAutoSubmitPage', false)
				this.eventBus.$emit('isShowAutoSubmit', false)
				this.isAutoSubmit = false
			}
			//----------
			this.eventBus.$emit('miniScaleState', false)
			this.isSelFastScoreBoard = false
			this.scoreList.forEach(res => {
				res.getScore = null
			})
			this.eventBus.$emit('emitScoreList', this.scoreList)
		},
		// 快捷打分
		fastClickChange(val) {
			this.currentIndex = 0
			this.emitAllScoreState()
			if (this.isHistoryState) {
				this.isShowAutoSubmit = false
			} else {
				this.isShowAutoSubmit = !val
			}
			this.isFastScoreState = val
			this.emitCurrentStepScoreFun()
			if (this.isHistoryState) {
				this.eventBus.$emit('changeFastScoreInfo', { key: '+', val: this.scoreList[0].stepScore })
			}
			this.eventBus.$emit('imgAddrListInfo', { imgAddrList: {} })
			this.eventBus.$emit('isFastScoreState', val)
			this.eventBus.$emit('fastScoreBoardState', val)
			this.eventBus.$emit('scoreBoardState', false)
			this.eventBus.$emit('isScoreBoardState', false)
			this.eventBus.$emit('miniScaleState', false)
			this.isSelScoreBoard = false
			this.isSelHorizontalPage = true
			this.eventBus.$emit('horizontalChange', false)
			this.eventBus.$emit('')
		},
		//	自动提交
		aotuSubmitChange(val) {
			// this.isSelAutoSubmit = true
			this.isAutoSubmit = val
			this.eventBus.$emit('isAutoSubmitPage', val)
		},
		//	横板
		horizontalChange(val) {
			this.isHorizontalImage = val
			this.eventBus.$emit('horizontalChange', val)
		},
		// 参考答案
		answerChange(val) {
			this.eventBus.$emit('answerChange', val)
		},
		//	缓存数据
		cacheData(val) {
			this.eventBus.$emit('isCacheNextData', val)
		},
		//	提交 BTN
		submitScoreBtn() {
			this.submitScore()
		},
		//	提交
		async submitScore() {
			if (!this.isScoreLegal) {
				this.$message({ type: 'error', message: '打分不合法!', duration: 3000, dangerouslyUseHTMLString: true })
				return false
			}
			if (this.loadingState) return false
			const self = this
			this.loadingState = true
			isAllGetScore(this.scoreList).then(res => {
				if (Number(this.allBasicInfo.studentId) < 0) {
					this.$message({ type: 'error', message: '暂无试卷', duration: 3000 })
					this.loadingState = false
					return false
				}
				if (res) {
					const duration = new Date().getTime() - this.startTime
					import('../utils/help').then(resp => {
						resp.submitScore(
							this,
							this.query,
							this.scoreList,
							this.allBasicInfo,
							this.imgAddrMarkList,
							duration,
							this.examType,
							this.isFastScoreState,
							this.isHorizontalImage,
							this.examRemark
						).then(res => {
							self.changeState()
							setTimeout(() => {
								self.loadingState = false
							}, 50)
							if (res.code === '200') {
								this.eventBus.$emit('flushData')
								this.eventBus.$emit('isHistoryState', false)
								this.$bigScore({ score: this.totalScore, dom: this.$parent.$refs['home'] })
								this.eventBus.$emit('isTypical', { state: false })
								if (this.isFastScoreState) {
									this.eventBus.$emit('isShowAutoSubmit', false)
								}
							}
						})
					})
				} else {
					this.$message({ message: '请对所有题目打分', type: 'error', duration: 3000 })
					self.loadingState = false
				}
			})
		},
		changeState() {
			if (this.isHistoryState) {
				this.eventBus.$emit('historyBoardState', false)
				this.eventBus.$emit('isCacheNextData', false)
				this.eventBus.$emit('isFastScoreState', false)
				this.eventBus.$emit('isShowAutoSubmit', true)
				this.eventBus.$emit('isAutoSubmitPage', true)
			}
		},
		//	 当前满分
		fullScore(val, index) {
			this.currentIndex = index
			this.scoreList[index].getScore = val
			this.getTotalScore()
			this.emitAllScoreState()
			this.FullZeroScore()
		},
		// 当前零分
		zeroScore(index) {
			this.currentIndex = index
			this.scoreList[index].getScore = 0
			this.getTotalScore()
			this.emitAllScoreState()
			this.FullZeroScore()
		},
		FullZeroScore() {
			if (this.isFastScoreState) {
				this.$delete(this.imgAddrMarkList, `active${this.currentIndex}`)
				this.eventBus.$emit('imgAddrListInfo', { imgAddrList: this.imgAddrMarkList })
			}
			if (this.isHistoryState || !this.isAutoSubmit) return false
			import('../utils/help').then(resp => {
				resp.isAllGetScore(this.scoreList).then(responce => {
					if (responce) this.submitScore()
				})
			})
		},
		// 全对
		allRight() {
			this.eventBus.$emit('imgAddrListInfo', { imgAddrList: {} })
			this.totalScore = 0
			this.scoreList.forEach(res => {
				res.getScore = res.score
				this.totalScore += res.score
			})
			this.emitAllScoreState()
			this.getTotalScore()
			if (this.isHistoryState) return false
			this.submitScore()
		},
		// 全错
		allWrong() {
			this.eventBus.$emit('imgAddrListInfo', { imgAddrList: {} })
			this.totalScore = 0
			this.scoreList.forEach(res => (res.getScore = 0))
			this.emitAllScoreState()
			this.getTotalScore()
			if (this.isHistoryState) return false
			this.submitScore()
		},
		// emit 所有的 成绩状态
		emitAllScoreState() {
			this.eventBus.$emit('emitScoreList', this.scoreList)
			this.eventBus.$emit('emitScoreCurrentIndex', this.currentIndex)
		},
		// 获取总分
		getTotalScore() {
			this.totalScore = 0
			let temporyVar = 0
			this.scoreList.forEach(res => {
				temporyVar += Number(res.getScore) || 0
			})
			this.totalScore = temporyVar
		},
		//     最小化打分板
		miniScoreBoard() {
			if (!this.isFastScoreState && !this.isSelScoreBoard && this.markBoardState) this.eventBus.$emit('markBoardState', false)
			this.isDisplayMarkScoreBoard = false
		}
	}
}
</script>

<style scoped lang="less">
.mark-bard {
	width: 360px;
	.mark-board-content {
		width: 360px;
		background: white;
		position: absolute;
		right: 0;
		top: 0;
		cursor: move;
		padding: 0 14px;
		box-sizing: border-box;
		border-radius: 8px;
		box-shadow: 0 0 10px rgb(185, 180, 180);
		z-index: 2;
		transform: translateX(-60px);
		@media screen and (max-width: 1920px) {
			width: 300px !important;
			transform: translateX(-35px);
		}
	}
	.account {
		height: 32px;
		line-height: 32px;
		font-size: 16px;
		color: #ff7200;
		border-bottom: 1px solid #e6e6e6;
		.iconfont {
			float: right;
			color: #606266;
			cursor: pointer;
			font-weight: bold;
		}
		.iconzuixiaohua {
			display: inline-block;
			margin-right: 15px;
			font-size: 20px;
		}
	}
	.score {
		height: 30px;
		margin-top: 12px;
		display: flex;
		justify-content: flex-start;
		.score-title {
			max-width: 200px;
			font-size: 14px;
			color: #000000;
			line-height: 26px;
			font-weight: 500;
			text-align: left;
			@media screen and (max-width: 1920px) {
				font-size: 14px;
			}
		}
		.score-num {
			width: 40px;
			height: 26px;
			margin-left: 10px;
			border: 1px solid #dcdfe6;
			border-radius: 4px;
			.score-input {
				display: inline-block;
				width: 100%;
				height: 100%;
				border: none;
				outline: none;
				padding-left: 5px;
				box-sizing: border-box;
				&::-webkit-input-placeholder {
					color: #dcdfe6;
				}

				&:-moz-placeholder {
					color: #dcdfe6;
				}

				&::-moz-placeholder {
					color: #dcdfe6;
				}

				&:-ms-input-placeholder {
					color: #dcdfe6;
				}
			}
		}
		.score-num-active {
			border: 1px solid red;
			border-radius: 4px;
		}
		.btn {
			width: 40px;
			height: 30px;
			background: #009688;
			border: 1px solid #009688;
			border-radius: 2px;
			box-sizing: border-box;
			margin-left: 5px;
			text-align: center;
			line-height: 30px;
			font-size: 15px;
			font-weight: 400;
			color: #ffffff;
			cursor: pointer;
		}
		.yellow-btn {
			background: #ff7200;
			border: 1px solid #ff7200;
		}
	}
	.total-ope {
		margin: 10px 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.all-btn-wrap {
			display: flex;
			justify-content: flex-start;
		}

		.all-btn {
			width: 95px;
			height: 30px;
			background: #009688;
			border: 1px solid #009688;
			border-radius: 2px;
			text-align: center;
			line-height: 30px;
			color: #ffffff;
			font-size: 16px;
			cursor: pointer;
			@media screen and (max-width: 1920px) {
				width: 60px;
			}
		}
		.all-right {
			margin-right: 35px;
		}
		.all-wrong {
			background: #ff7200;
			border: 1px solid #ff7200;
		}
	}
	.score-info {
		display: flex;
		justify-content: space-between;
		align-items: center;
		line-height: 32px;
		.total-score {
			flex: 1;
			color: #999999;
			font-size: 16px;
			.total {
				color: #fa4c59;
				font-size: 24px;
				@media screen and (max-width: 1920px) {
					font-size: 18px;
				}
			}
		}
		.step-state {
			flex: 1;
			display: flex;
			align-items: center;
			color: #999999;
			.step-state-val {
				font-size: 16px;
			}
		}
	}
	.ope-check-box {
		padding: 10px 0 0;
		border-top: 1px solid #e6e6e6;
		/deep/.el-checkbox {
			height: 30px;
			margin-right: 2px;
			margin-bottom: 10px;
		}
		/deep/.el-checkbox.is-bordered {
			padding: 6px 20px 9px 10px;
			@media screen and (max-width: 1920px) {
				padding: 5px 8px 5px 8px;
			}
		}
		/deep/.el-checkbox__inner {
			width: 16px;
			height: 16px;
		}
		/deep/.el-checkbox__label {
			font-size: 16px;
		}
	}
	.btn-wrap {
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: wrap;
	}
	.history-wrap {
		width: 100%;
		display: flex;
		.history-btn {
			flex: 1;
			height: 37px;
			background: #009688;
			border: 1px solid #009688;
			border-radius: 2px;
			text-align: center;
			line-height: 37px;
			font-size: 17px;
			font-weight: 500;
			color: white;
			margin-bottom: 10px;
			cursor: pointer;
		}
		.history-prev {
			margin-left: 20px;
		}
	}
	.final-btn {
		flex: 1;
		height: 42px;
		background: #ff7200;
		border: 1px solid #ff7200;
		border-radius: 2px;
		text-align: center;
		line-height: 42px;
		font-size: 17px;
		font-weight: 500;
		color: white;
		margin-bottom: 10px;
		cursor: pointer;
		@media screen and (max-width: 1920px) {
			height: 36px;
			line-height: 36px;
		}
	}
	.back-btn {
		background: #009688;
		border: 1px solid #009688;
		margin-right: 20px;
	}
	.next-qus {
		background: #009688;
		border: 1px solid #009688;
		margin-left: 20px;
	}
	.loading-btn-state {
		background: #4e4945;
		border: 1px solid #4e4945;
	}
}
</style>
